import React, { useState } from "react";
import styles from "../styles/help.module.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Help = () => {
  const [activeTab, setActiveTab] = useState("usage");

  const tabs = [
    { id: "usage", label: "How to Use", icon: "fas fa-book" },
    { id: "practices", label: "Best Practices", icon: "fas fa-shield-alt" },
    { id: "faq", label: "FAQ", icon: "fas fa-question-circle" },
  ];

  const features = [
    {
      icon: "fas fa-user-circle",
      title: "Profile Setup",
      desc: "Configure your profile and upload your resume",
    },
    {
      icon: "fas fa-search",
      title: "Job Search",
      desc: "Set your preferences including location, experience level, and work type",
    },
    {
      icon: "fas fa-rocket",
      title: "Auto Apply",
      desc: "Start the automated application process with one click",
    },
    {
      icon: "fas fa-chart-line",
      title: "Monitor Progress",
      desc: "Track your daily and monthly application limits",
    },
  ];

  const bestPractices = [
    {
      icon: "fas fa-file-pdf",
      title: "Resume Management",
      desc: "Keep your resume up-to-date and in PDF format for optimal compatibility",
    },
    {
      icon: "fas fa-bullseye",
      title: "Job Targeting",
      desc: "Use specific job titles and keywords that match your skills",
    },
    {
      icon: "fas fa-money-bill-wave",
      title: "CTC Expectations",
      desc: "Set reasonable compensation expectations based on market research",
    },
    {
      icon: "fas fa-sync",
      title: "Regular Updates",
      desc: "Keep your LinkedIn profile and application preferences current",
    },
  ];

  const faqs = [
    {
      question: "Is this tool safe to use with my LinkedIn account?",
      answer:
        "Yes, the tool respects LinkedIn's rate limits and guidelines. However, always use automation tools responsibly.",
    },
    {
      question: "How many applications can I submit per day?",
      answer:
        "The tool limits you to 40 applications per day to comply with LinkedIn's guidelines.",
    },
    {
      question: "Can I customize my application responses?",
      answer:
        "Yes, you can set up custom responses for common application questions in your profile.",
    },
  ];

  return (
    <div className={styles.infoSection}>
      <h2 className={styles.infoTitle}>Help & Documentation</h2>

      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`${styles.tabBtn} ${
                activeTab === tab.id ? styles.active : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={tab.icon}></i> {tab.label}
            </button>
          ))}
        </div>

        <div
          className={`${styles.tabContent} ${
            activeTab === "usage" ? styles.active : ""
          }`}
        >
          <h3>How to Use the Application</h3>
          <div className={styles.featureGrid}>
            {features.map((feature, index) => (
              <div key={index} className={styles.feature}>
                <i className={feature.icon}></i>
                <h4>{feature.title}</h4>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div
          className={`${styles.tabContent} ${
            activeTab === "practices" ? styles.active : ""
          }`}
        >
          <h3>Best Practices</h3>
          <div className={styles.practicesGrid}>
            {bestPractices.map((practice, index) => (
              <div key={index} className={styles.practiceItem}>
                <i className={practice.icon}></i>
                <div>
                  <h4>{practice.title}</h4>
                  <p>{practice.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          className={`${styles.tabContent} ${
            activeTab === "faq" ? styles.active : ""
          }`}
        >
          <h3>Frequently Asked Questions</h3>
          <div className={styles.faqList}>
            {faqs.map((faq, index) => (
              <div key={index} className={styles.faqItem}>
                <div className={styles.faqQuestion}>
                  <i className="fas fa-question-circle"></i>
                  <h4>{faq.question}</h4>
                </div>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
